import { render, staticRenderFns } from "./MessageWrapper.vue?vue&type=template&id=fabb5ec0&scoped=true&"
import script from "./MessageWrapper.vue?vue&type=script&lang=js&"
export * from "./MessageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MessageWrapper.vue?vue&type=style&index=0&id=fabb5ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabb5ec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
